export const SECOND_MULTIPLIER = 1e3;

// Earliest month with broker data, as `yyyy-MM` - the lower bound of the
// month picker.
export const DATA_START_MONTH = '2024-05';

// The /buckets endpoint always applies a row LIMIT (defaulting to 1 when
// absent), so the request pins it to the endpoint's ceiling - comfortably
// above a month of 15-minute buckets.
export const MAX_BUCKETS_LIMIT = 1000;

// TODO: replace this with tailwind color
export const THEME = {
    bg: '#ffffff',
    tickTextColor: '#242424',
};

export const CriteriaMap: Record<string, string> = {
    place_order: 'Place Order',
    modify_order: 'Modify Order',
    cancel_order: 'Cancel Order',
};

export const CriteriaInfoMap: Record<string, string> = {
    place_order: 'API acknowledgment time for placing an order.',
    modify_order: 'API acknowledgment time for modifying an order.',
    cancel_order: 'API acknowledgment time for cancelling an order.',
};

export const MetricInfoMap: Record<string, string> = {
    median: 'The middle response time across all requests.',
    p90: 'Represents the slower end of the broker’s typical response times. 90 out of 100 requests are completed within this time.',
    p99: 'Represents near worst-case response time. 99 out of 100 requests are completed within this time, while the slowest 1% may take longer.',
    p10: 'Represents the faster end of the broker’s response times. 10 out of 100 requests are completed within this time.',
    stdDev: 'Shows how much response times vary. Lower means more consistent.',
};

export const SORT_ASC = 'asc';
export const SORT_DESC = 'desc';

export const METRIC_FIELD_MEDIAN = 'median';
export const METRIC_FIELD_PERCENTILE_10 = 'percentile_10';
export const METRIC_FIELD_PERCENTILE_90 = 'percentile_90';
export const METRIC_FIELD_PERCENTILE_99 = 'percentile_99';

// The numbers table's sortable columns.
export const SORT_COLUMN_BROKER = 'broker';
export const SORT_COLUMN_MEDIAN = 'median';
export const SORT_COLUMN_P90 = 'p90';
export const SORT_COLUMN_P99 = 'p99';
export const SORT_COLUMN_P10 = 'p10';
export const SORT_COLUMN_STD_DEV = 'stdDev';
